import type { DefaultApi } from "@/api";
import { PositionQualificationChat } from "@/models/position_qualification_chat";
import { PositionQualificationChats } from "@/models/position_qualification_chats";
import type { State as RootState } from "@/stores";
import type { Module } from "vuex";
export interface State {
  positionQualificationChats?: PositionQualificationChats;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    positionQualificationChats: undefined,
  },
  actions: {
    async getLatestPositionQualificationChat({ commit }, positionId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getLatestPositionQualificationChat(positionId);
      const chats = new PositionQualificationChats(
        response.data.map(
          (chat: Partial<PositionQualificationChat>) =>
            new PositionQualificationChat(chat),
        ),
      );
      commit("setPositionQualificationChats", chats);
      return chats;
    },
    async postPositionQualificationChat({ commit }, positionId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postPositionQualificationChat(positionId);
      const chats = new PositionQualificationChats(
        response.data.map(
          (chat: Partial<PositionQualificationChat>) =>
            new PositionQualificationChat(chat),
        ),
      );
      commit("setPositionQualificationChats", chats);
      return chats;
    },
  },
  mutations: {
    setPositionQualificationChats(state, chats: PositionQualificationChats) {
      state.positionQualificationChats = chats;
    },
  },
};
